import React from 'react';
import Breadcrumb from 'Common/BreadCrumb';
import { Card, Col, Container, Row } from 'react-bootstrap';

const BootstrapIcon = () => {
    document.title=" Bootstrap Icons | Steex Admin & Dashboard Template";

  return (
    <React.Fragment>
      <div className="page-content">       
        <Container fluid>
        <Breadcrumb pageTitle="Icons" title="BootStrap" />
            <Row>
                <Col className="col-12">
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Examples</h4>
                            <p className="text-muted mb-0">Use <code>&lt;i className="bi bi-**"{'>'}&lt;/i{'>'}</code> class.</p>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <Row className="icon-demo-content" id="iconList">
                                <Col xl={3} lg={4} sm={6}> 
                                    <i className="bi bi-123"></i> 123
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-alarm-fill"></i> alarm-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-alarm"></i> alarm
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-bottom"></i> align-bottom
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-center"></i> align-center
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-end"></i> align-end
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-middle"></i> align-middle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-start"></i> align-start
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-align-top"></i> align-top
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-alt"></i> alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-app-indicator"></i> app-indicator
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-app"></i> app
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-archive-fill"></i> archive-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-archive"></i> archive
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-90deg-down"></i> arrow-90deg-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-90deg-left"></i> arrow-90deg-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-90deg-right"></i> arrow-90deg-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-90deg-up"></i> arrow-90deg-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-bar-down"></i> arrow-bar-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-bar-left"></i> arrow-bar-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-bar-right"></i> arrow-bar-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-bar-up"></i> arrow-bar-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-clockwise"></i> arrow-clockwise
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-counterclockwise"></i> arrow-counterclockwise
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-circle-fill"></i> arrow-down-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-circle"></i> arrow-down-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-left-circle-fill"></i> arrow-down-left-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-left-circle"></i> arrow-down-left-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-left-square-fill"></i> arrow-down-left-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-left-square"></i> arrow-down-left-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-left"></i> arrow-down-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-right-circle-fill"></i> arrow-down-right-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-right-circle"></i> arrow-down-right-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-right-square-fill"></i> arrow-down-right-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-right-square"></i> arrow-down-right-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-right"></i> arrow-down-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-short"></i> arrow-down-short
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-square-fill"></i> arrow-down-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-square"></i> arrow-down-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down-up"></i> arrow-down-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-down"></i> arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-circle-fill"></i> arrow-left-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-circle"></i> arrow-left-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-right"></i> arrow-left-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-short"></i> arrow-left-short
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-square-fill"></i> arrow-left-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left-square"></i> arrow-left-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-left"></i> arrow-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-repeat"></i> arrow-repeat
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-return-left"></i> arrow-return-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-return-right"></i> arrow-return-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right-circle-fill"></i> arrow-right-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right-circle"></i> arrow-right-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right-short"></i> arrow-right-short
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right-square-fill"></i> arrow-right-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right-square"></i> arrow-right-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-right"></i> arrow-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-circle-fill"></i> arrow-up-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-circle"></i> arrow-up-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-left-circle-fill"></i> arrow-up-left-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-left-circle"></i> arrow-up-left-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-left-square-fill"></i> arrow-up-left-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-left-square"></i> arrow-up-left-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-left"></i> arrow-up-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-right-circle-fill"></i> arrow-up-right-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-right-circle"></i> arrow-up-right-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-right-square-fill"></i> arrow-up-right-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-right-square"></i> arrow-up-right-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-right"></i> arrow-up-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-short"></i> arrow-up-short
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-square-fill"></i> arrow-up-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up-square"></i> arrow-up-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-up"></i> arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-angle-contract"></i> arrows-angle-contract
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-angle-expand"></i> arrows-angle-expand
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-collapse"></i> arrows-collapse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-expand"></i> arrows-expand
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-fullscreen"></i> arrows-fullscreen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrows-move"></i> arrows-move
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-aspect-ratio-fill"></i> aspect-ratio-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-aspect-ratio"></i> aspect-ratio
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-asterisk"></i> asterisk
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-at"></i> at
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-award-fill"></i> award-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-award"></i> award
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-back"></i> back
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-backspace-fill"></i> backspace-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-backspace-reverse-fill"></i> backspace-reverse-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-backspace-reverse"></i> backspace-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-backspace"></i> backspace
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-3d-fill"></i> badge-3d-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-3d"></i> badge-3d
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-4k-fill"></i> badge-4k-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-4k"></i> badge-4k
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-8k-fill"></i> badge-8k-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-8k"></i> badge-8k
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-ad-fill"></i> badge-ad-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-ad"></i> badge-ad
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-ar-fill"></i> badge-ar-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-ar"></i> badge-ar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-cc-fill"></i> badge-cc-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-cc"></i> badge-cc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-hd-fill"></i> badge-hd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-hd"></i> badge-hd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-tm-fill"></i> badge-tm-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-tm"></i> badge-tm
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-vo-fill"></i> badge-vo-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-vo"></i> badge-vo
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-vr-fill"></i> badge-vr-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-vr"></i> badge-vr
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-wc-fill"></i> badge-wc-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-wc"></i> badge-wc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-check-fill"></i> bag-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-check"></i> bag-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-dash-fill"></i> bag-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-dash"></i> bag-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-fill"></i> bag-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-plus-fill"></i> bag-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-plus"></i> bag-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-x-fill"></i> bag-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-x"></i> bag-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag"></i> bag
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bar-chart-fill"></i> bar-chart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bar-chart-line-fill"></i> bar-chart-line-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bar-chart-line"></i> bar-chart-line
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bar-chart-steps"></i> bar-chart-steps
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bar-chart"></i> bar-chart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket-fill"></i> basket-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket"></i> basket
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket2-fill"></i> basket2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket2"></i> basket2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket3-fill"></i> basket3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-basket3"></i> basket3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-battery-charging"></i> battery-charging
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-battery-full"></i> battery-full
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-battery-half"></i> battery-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-battery"></i> battery
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bell-fill"></i> bell-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bell"></i> bell
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bezier"></i> bezier
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bezier2"></i> bezier2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bicycle"></i> bicycle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-binoculars-fill"></i> binoculars-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-binoculars"></i> binoculars
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-blockquote-left"></i> blockquote-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-blockquote-right"></i> blockquote-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-book-fill"></i> book-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-book-half"></i> book-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-book"></i> book
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-check-fill"></i> bookmark-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-check"></i> bookmark-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-dash-fill"></i> bookmark-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-dash"></i> bookmark-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-fill"></i> bookmark-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-heart-fill"></i> bookmark-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-heart"></i> bookmark-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-plus-fill"></i> bookmark-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-plus"></i> bookmark-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-star-fill"></i> bookmark-star-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-star"></i> bookmark-star
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-x-fill"></i> bookmark-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark-x"></i> bookmark-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmark"></i> bookmark
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmarks-fill"></i> bookmarks-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookmarks"></i> bookmarks
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bookshelf"></i> bookshelf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bootstrap-fill"></i> bootstrap-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bootstrap-reboot"></i> bootstrap-reboot
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bootstrap"></i> bootstrap
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-all"></i> border-all
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-bottom"></i> border-bottom
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-center"></i> border-center
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-inner"></i> border-inner
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-left"></i> border-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-middle"></i> border-middle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-outer"></i> border-outer
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-right"></i> border-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-style"></i> border-style
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-top"></i> border-top
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border-width"></i> border-width
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-border"></i> border
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bounding-box-circles"></i> bounding-box-circles
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bounding-box"></i> bounding-box
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-down-left"></i> box-arrow-down-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-down-right"></i> box-arrow-down-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-down"></i> box-arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-down-left"></i> box-arrow-in-down-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-down-right"></i> box-arrow-in-down-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-down"></i> box-arrow-in-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-left"></i> box-arrow-in-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-right"></i> box-arrow-in-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-up-left"></i> box-arrow-in-up-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-up-right"></i> box-arrow-in-up-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-in-up"></i> box-arrow-in-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-left"></i> box-arrow-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-right"></i> box-arrow-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-up-left"></i> box-arrow-up-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-up-right"></i> box-arrow-up-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-arrow-up"></i> box-arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-seam"></i> box-seam
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box"></i> box
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-braces"></i> braces
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bricks"></i> bricks
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-briefcase-fill"></i> briefcase-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-briefcase"></i> briefcase
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-alt-high-fill"></i> brightness-alt-high-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-alt-high"></i> brightness-alt-high
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-alt-low-fill"></i> brightness-alt-low-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-alt-low"></i> brightness-alt-low
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-high-fill"></i> brightness-high-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-high"></i> brightness-high
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-low-fill"></i> brightness-low-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brightness-low"></i> brightness-low
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-broadcast-pin"></i> broadcast-pin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-broadcast"></i> broadcast
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brush-fill"></i> brush-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-brush"></i> brush
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bucket-fill"></i> bucket-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bucket"></i> bucket
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bug-fill"></i> bug-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bug"></i> bug
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-building"></i> building
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bullseye"></i> bullseye
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calculator-fill"></i> calculator-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calculator"></i> calculator
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-check-fill"></i> calendar-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-check"></i> calendar-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-date-fill"></i> calendar-date-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-date"></i> calendar-date
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-day-fill"></i> calendar-day-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-day"></i> calendar-day
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-event-fill"></i> calendar-event-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-event"></i> calendar-event
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-fill"></i> calendar-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-minus-fill"></i> calendar-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-minus"></i> calendar-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-month-fill"></i> calendar-month-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-month"></i> calendar-month
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-plus-fill"></i> calendar-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-plus"></i> calendar-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-range-fill"></i> calendar-range-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-range"></i> calendar-range
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-week-fill"></i> calendar-week-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-week"></i> calendar-week
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-x-fill"></i> calendar-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-x"></i> calendar-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar"></i> calendar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-check-fill"></i> calendar2-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-check"></i> calendar2-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-date-fill"></i> calendar2-date-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-date"></i> calendar2-date
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-day-fill"></i> calendar2-day-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-day"></i> calendar2-day
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-event-fill"></i> calendar2-event-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-event"></i> calendar2-event
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-fill"></i> calendar2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-minus-fill"></i> calendar2-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-minus"></i> calendar2-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-month-fill"></i> calendar2-month-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-month"></i> calendar2-month
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-plus-fill"></i> calendar2-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-plus"></i> calendar2-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-range-fill"></i> calendar2-range-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-range"></i> calendar2-range
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-week-fill"></i> calendar2-week-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-week"></i> calendar2-week
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-x-fill"></i> calendar2-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-x"></i> calendar2-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2"></i> calendar2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-event-fill"></i> calendar3-event-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-event"></i> calendar3-event
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-fill"></i> calendar3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-range-fill"></i> calendar3-range-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-range"></i> calendar3-range
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-week-fill"></i> calendar3-week-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3-week"></i> calendar3-week
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar3"></i> calendar3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar4-event"></i> calendar4-event
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar4-range"></i> calendar4-range
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar4-week"></i> calendar4-week
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar4"></i> calendar4
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-fill"></i> camera-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-reels-fill"></i> camera-reels-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-reels"></i> camera-reels
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-video-fill"></i> camera-video-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-video-off-fill"></i> camera-video-off-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-video-off"></i> camera-video-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera-video"></i> camera-video
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera"></i> camera
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-camera2"></i> camera2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-capslock-fill"></i> capslock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-capslock"></i> capslock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-card-checklist"></i> card-checklist
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-card-heading"></i> card-heading
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-card-image"></i> card-image
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-card-list"></i> card-list
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-card-text"></i> card-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-down-fill"></i> caret-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-down-square-fill"></i> caret-down-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-down-square"></i> caret-down-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-down"></i> caret-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-left-fill"></i> caret-left-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-left-square-fill"></i> caret-left-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-left-square"></i> caret-left-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-left"></i> caret-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-right-fill"></i> caret-right-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-right-square-fill"></i> caret-right-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-right-square"></i> caret-right-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-right"></i> caret-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-up-fill"></i> caret-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-up-square-fill"></i> caret-up-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-up-square"></i> caret-up-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-caret-up"></i> caret-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-check-fill"></i> cart-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-check"></i> cart-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-dash-fill"></i> cart-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-dash"></i> cart-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-fill"></i> cart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-plus-fill"></i> cart-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-plus"></i> cart-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-x-fill"></i> cart-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart-x"></i> cart-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart"></i> cart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart2"></i> cart2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart3"></i> cart3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cart4"></i> cart4
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cash-stack"></i> cash-stack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cash"></i> cash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cast"></i> cast
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-dots-fill"></i> chat-dots-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-dots"></i> chat-dots
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-fill"></i> chat-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-dots-fill"></i> chat-left-dots-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-dots"></i> chat-left-dots
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-fill"></i> chat-left-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-quote-fill"></i> chat-left-quote-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-quote"></i> chat-left-quote
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-text-fill"></i> chat-left-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-text"></i> chat-left-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left"></i> chat-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-quote-fill"></i> chat-quote-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-quote"></i> chat-quote
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-dots-fill"></i> chat-right-dots-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-dots"></i> chat-right-dots
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-fill"></i> chat-right-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-quote-fill"></i> chat-right-quote-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-quote"></i> chat-right-quote
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-text-fill"></i> chat-right-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-text"></i> chat-right-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right"></i> chat-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-dots-fill"></i> chat-square-dots-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-dots"></i> chat-square-dots
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-fill"></i> chat-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-quote-fill"></i> chat-square-quote-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-quote"></i> chat-square-quote
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-text-fill"></i> chat-square-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-text"></i> chat-square-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square"></i> chat-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-text-fill"></i> chat-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-text"></i> chat-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat"></i> chat
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-all"></i> check-all
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-circle-fill"></i> check-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-circle"></i> check-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-square-fill"></i> check-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-square"></i> check-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check"></i> check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check2-all"></i> check2-all
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check2-circle"></i> check2-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check2-square"></i> check2-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check2"></i> check2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-contract"></i> chevron-bar-contract
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-down"></i> chevron-bar-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-expand"></i> chevron-bar-expand
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-left"></i> chevron-bar-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-right"></i> chevron-bar-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-bar-up"></i> chevron-bar-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-compact-down"></i> chevron-compact-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-compact-left"></i> chevron-compact-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-compact-right"></i> chevron-compact-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-compact-up"></i> chevron-compact-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-contract"></i> chevron-contract
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-double-down"></i> chevron-double-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-double-left"></i> chevron-double-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-double-right"></i> chevron-double-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-double-up"></i> chevron-double-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-down"></i> chevron-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-expand"></i> chevron-expand
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-left"></i> chevron-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-right"></i> chevron-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chevron-up"></i> chevron-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-circle-fill"></i> circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-circle-half"></i> circle-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-circle-square"></i> circle-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-circle"></i> circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-check"></i> clipboard-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-data"></i> clipboard-data
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-minus"></i> clipboard-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-plus"></i> clipboard-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-x"></i> clipboard-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard"></i> clipboard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clock-fill"></i> clock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clock-history"></i> clock-history
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clock"></i> clock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-arrow-down-fill"></i> cloud-arrow-down-fill
                                </Col>    
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-arrow-down"></i> cloud-arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-arrow-up-fill"></i> cloud-arrow-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-arrow-up"></i> cloud-arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-check-fill"></i> cloud-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-check"></i> cloud-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-download-fill"></i> cloud-download-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-download"></i> cloud-download
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-drizzle-fill"></i> cloud-drizzle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-drizzle"></i> cloud-drizzle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-fill"></i> cloud-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-fog-fill"></i> cloud-fog-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-fog"></i> cloud-fog
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-fog2-fill"></i> cloud-fog2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-fog2"></i> cloud-fog2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-hail-fill"></i> cloud-hail-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-hail"></i> cloud-hail
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-haze-1"></i> cloud-haze-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-haze-fill"></i> cloud-haze-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-haze"></i> cloud-haze
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-haze2-fill"></i> cloud-haze2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-lightning-fill"></i> cloud-lightning-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-lightning-rain-fill"></i> cloud-lightning-rain-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-lightning-rain"></i> cloud-lightning-rain
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-lightning"></i> cloud-lightning
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-minus-fill"></i> cloud-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-minus"></i> cloud-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-moon-fill"></i> cloud-moon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-moon"></i> cloud-moon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-plus-fill"></i> cloud-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-plus"></i> cloud-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-rain-fill"></i> cloud-rain-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-rain-heavy-fill"></i> cloud-rain-heavy-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-rain-heavy"></i> cloud-rain-heavy
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-rain"></i> cloud-rain
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-slash-fill"></i> cloud-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-slash"></i> cloud-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-sleet-fill"></i> cloud-sleet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-sleet"></i> cloud-sleet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-snow-fill"></i> cloud-snow-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-snow"></i> cloud-snow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-sun-fill"></i> cloud-sun-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-sun"></i> cloud-sun
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-upload-fill"></i> cloud-upload-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-upload"></i> cloud-upload
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud"></i> cloud
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clouds-fill"></i> clouds-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clouds"></i> clouds
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloudy-fill"></i> cloudy-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloudy"></i> cloudy
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-code-slash"></i> code-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-code-square"></i> code-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-code"></i> code
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-collection-fill"></i> collection-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-collection-play-fill"></i> collection-play-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-collection-play"></i> collection-play
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-collection"></i> collection
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-columns-gap"></i> columns-gap
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-columns"></i> columns
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-command"></i> command
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-compass-fill"></i> compass-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-compass"></i> compass
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cone-striped"></i> cone-striped
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cone"></i> cone
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-controller"></i> controller
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cpu-fill"></i> cpu-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cpu"></i> cpu
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card-2-back-fill"></i> credit-card-2-back-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card-2-back"></i> credit-card-2-back
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card-2-front-fill"></i> credit-card-2-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card-2-front"></i> credit-card-2-front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card-fill"></i> credit-card-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-credit-card"></i> credit-card
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-crop"></i> crop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cup-fill"></i> cup-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cup-straw"></i> cup-straw
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cup"></i> cup
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cursor-fill"></i> cursor-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cursor-text"></i> cursor-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cursor"></i> cursor
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-circle-dotted"></i> dash-circle-dotted
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-circle-fill"></i> dash-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-circle"></i> dash-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-square-dotted"></i> dash-square-dotted
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-square-fill"></i> dash-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-square"></i> dash-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash"></i> dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diagram-2-fill"></i> diagram-2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diagram-2"></i> diagram-2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diagram-3-fill"></i> diagram-3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diagram-3"></i> diagram-3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diamond-fill"></i> diamond-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diamond-half"></i> diamond-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-diamond"></i> diamond
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-1-fill"></i> dice-1-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-1"></i> dice-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-2-fill"></i> dice-2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-2"></i> dice-2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-3-fill"></i> dice-3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-3"></i> dice-3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-4-fill"></i> dice-4-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-4"></i> dice-4
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-5-fill"></i> dice-5-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-5"></i> dice-5
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-6-fill"></i> dice-6-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dice-6"></i> dice-6
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-disc-fill"></i> disc-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-disc"></i> disc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-discord"></i> discord
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-display-fill"></i> display-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-display"></i> display
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-distribute-horizontal"></i> distribute-horizontal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-distribute-vertical"></i> distribute-vertical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-door-closed-fill"></i> door-closed-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-door-closed"></i> door-closed
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-door-open-fill"></i> door-open-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-door-open"></i> door-open
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dot"></i> dot
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-download"></i> download
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-droplet-fill"></i> droplet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-droplet-half"></i> droplet-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-droplet"></i> droplet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-earbuds"></i> earbuds
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel-fill"></i> easel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel"></i> easel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-egg-fill"></i> egg-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-egg-fried"></i> egg-fried
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-egg"></i> egg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eject-fill"></i> eject-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eject"></i> eject
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-angry-fill"></i> emoji-angry-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-angry"></i> emoji-angry
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-dizzy-fill"></i> emoji-dizzy-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-dizzy"></i> emoji-dizzy
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-expressionless-fill"></i> emoji-expressionless-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-expressionless"></i> emoji-expressionless
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-frown-fill"></i> emoji-frown-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-frown"></i> emoji-frown
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-heart-eyes-fill"></i> emoji-heart-eyes-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-heart-eyes"></i> emoji-heart-eyes
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-laughing-fill"></i> emoji-laughing-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-laughing"></i> emoji-laughing
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-neutral-fill"></i> emoji-neutral-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-neutral"></i> emoji-neutral
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-smile-fill"></i> emoji-smile-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-smile-upside-down-fill"></i> emoji-smile-upside-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-smile-upside-down"></i> emoji-smile-upside-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-smile"></i> emoji-smile
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-sunglasses-fill"></i> emoji-sunglasses-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-sunglasses"></i> emoji-sunglasses
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-wink-fill"></i> emoji-wink-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-wink"></i> emoji-wink
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-fill"></i> envelope-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-open-fill"></i> envelope-open-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-open"></i> envelope-open
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope"></i> envelope
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eraser-fill"></i> eraser-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eraser"></i> eraser
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-circle-fill"></i> exclamation-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-circle"></i> exclamation-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-diamond-fill"></i> exclamation-diamond-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-diamond"></i> exclamation-diamond
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-octagon-fill"></i> exclamation-octagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-octagon"></i> exclamation-octagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-square-fill"></i> exclamation-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-square"></i> exclamation-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-triangle-fill"></i> exclamation-triangle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-triangle"></i> exclamation-triangle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation"></i> exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclude"></i> exclude
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eye-fill"></i> eye-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eye-slash-fill"></i> eye-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eye-slash"></i> eye-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eye"></i> eye
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eyedropper"></i> eyedropper
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-eyeglasses"></i> eyeglasses
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-facebook"></i> facebook
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-arrow-down-fill"></i> file-arrow-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-arrow-down"></i> file-arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-arrow-up-fill"></i> file-arrow-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-arrow-up"></i> file-arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-bar-graph-fill"></i> file-bar-graph-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-bar-graph"></i> file-bar-graph
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-binary-fill"></i> file-binary-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-binary"></i> file-binary
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-break-fill"></i> file-break-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-break"></i> file-break
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-check-fill"></i> file-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-check"></i> file-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-code-fill"></i> file-code-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-code"></i> file-code
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-diff-fill"></i> file-diff-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-diff"></i> file-diff
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-arrow-down-fill"></i> file-earmark-arrow-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-arrow-down"></i> file-earmark-arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-arrow-up-fill"></i> file-earmark-arrow-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-arrow-up"></i> file-earmark-arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-bar-graph-fill"></i> file-earmark-bar-graph-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-bar-graph"></i> file-earmark-bar-graph
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-binary-fill"></i> file-earmark-binary-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-binary"></i> file-earmark-binary
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-break-fill"></i> file-earmark-break-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-break"></i> file-earmark-break
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-check-fill"></i> file-earmark-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-check"></i> file-earmark-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-code-fill"></i> file-earmark-code-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-code"></i> file-earmark-code
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-diff-fill"></i> file-earmark-diff-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-diff"></i> file-earmark-diff
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-easel-fill"></i> file-earmark-easel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-easel"></i> file-earmark-easel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-excel-fill"></i> file-earmark-excel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-excel"></i> file-earmark-excel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-fill"></i> file-earmark-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-font-fill"></i> file-earmark-font-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-font"></i> file-earmark-font
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-image-fill"></i> file-earmark-image-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-image"></i> file-earmark-image
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-lock-fill"></i> file-earmark-lock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-lock"></i> file-earmark-lock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-lock2-fill"></i> file-earmark-lock2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-lock2"></i> file-earmark-lock2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-medical-fill"></i> file-earmark-medical-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-medical"></i> file-earmark-medical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-minus-fill"></i> file-earmark-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-minus"></i> file-earmark-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-music-fill"></i> file-earmark-music-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-music"></i> file-earmark-music
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-person-fill"></i> file-earmark-person-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-person"></i> file-earmark-person
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-play-fill"></i> file-earmark-play-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-play"></i> file-earmark-play
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-plus-fill"></i> file-earmark-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-plus"></i> file-earmark-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-post-fill"></i> file-earmark-post-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-post"></i> file-earmark-post
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-ppt-fill"></i> file-earmark-ppt-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-ppt"></i> file-earmark-ppt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-richtext-fill"></i> file-earmark-richtext-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-richtext"></i> file-earmark-richtext
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-ruled-fill"></i> file-earmark-ruled-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-ruled"></i> file-earmark-ruled
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-slides-fill"></i> file-earmark-slides-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-slides"></i> file-earmark-slides
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-spreadsheet-fill"></i> file-earmark-spreadsheet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-spreadsheet"></i> file-earmark-spreadsheet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-text-fill"></i> file-earmark-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-text"></i> file-earmark-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-word-fill"></i> file-earmark-word-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-word"></i> file-earmark-word
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-x-fill"></i> file-earmark-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-x"></i> file-earmark-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-zip-fill"></i> file-earmark-zip-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-zip"></i> file-earmark-zip
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark"></i> file-earmark
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-easel-fill"></i> file-easel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-easel"></i> file-easel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-excel-fill"></i> file-excel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-excel"></i> file-excel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-fill"></i> file-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-font-fill"></i> file-font-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-font"></i> file-font
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-image-fill"></i> file-image-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-image"></i> file-image
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-lock-fill"></i> file-lock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-lock"></i> file-lock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-lock2-fill"></i> file-lock2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-lock2"></i> file-lock2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-medical-fill"></i> file-medical-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-medical"></i> file-medical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-minus-fill"></i> file-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-minus"></i> file-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-music-fill"></i> file-music-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-music"></i> file-music
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-person-fill"></i> file-person-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-person"></i> file-person
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-play-fill"></i> file-play-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-play"></i> file-play
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-plus-fill"></i> file-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-plus"></i> file-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-post-fill"></i> file-post-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-post"></i> file-post
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-ppt-fill"></i> file-ppt-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-ppt"></i> file-ppt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-richtext-fill"></i> file-richtext-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-richtext"></i> file-richtext
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-ruled-fill"></i> file-ruled-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-ruled"></i> file-ruled
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-slides-fill"></i> file-slides-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-slides"></i> file-slides
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-spreadsheet-fill"></i> file-spreadsheet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-spreadsheet"></i> file-spreadsheet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-text-fill"></i> file-text-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-text"></i> file-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-word-fill"></i> file-word-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-word"></i> file-word
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-x-fill"></i> file-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-x"></i> file-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-zip-fill"></i> file-zip-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-zip"></i> file-zip
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file"></i> file
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-files-alt"></i> files-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-files"></i> files
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-film"></i> film
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-circle-fill"></i> filter-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-circle"></i> filter-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-left"></i> filter-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-right"></i> filter-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-square-fill"></i> filter-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter-square"></i> filter-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filter"></i> filter
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-flag-fill"></i> flag-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-flag"></i> flag
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-flower1"></i> flower1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-flower2"></i> flower2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-flower3"></i> flower3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-check"></i> folder-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-fill"></i> folder-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-minus"></i> folder-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-plus"></i> folder-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-symlink-fill"></i> folder-symlink-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-symlink"></i> folder-symlink
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder-x"></i> folder-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder"></i> folder
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder2-open"></i> folder2-open
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-folder2"></i> folder2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fonts"></i> fonts
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-forward-fill"></i> forward-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-forward"></i> forward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-front"></i> front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fullscreen-exit"></i> fullscreen-exit
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fullscreen"></i> fullscreen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-funnel-fill"></i> funnel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-funnel"></i> funnel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gear-fill"></i> gear-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gear-wide-connected"></i> gear-wide-connected
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gear-wide"></i> gear-wide
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gear"></i> gear
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gem"></i> gem
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-geo-alt-fill"></i> geo-alt-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-geo-alt"></i> geo-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-geo-fill"></i> geo-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-geo"></i> geo
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gift-fill"></i> gift-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gift"></i> gift
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-github"></i> github
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-globe"></i> globe
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-globe2"></i> globe2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-google"></i> google
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-graph-down"></i> graph-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-graph-up"></i> graph-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-1x2-fill"></i> grid-1x2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-1x2"></i> grid-1x2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x2-gap-fill"></i> grid-3x2-gap-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x2-gap"></i> grid-3x2-gap
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x2"></i> grid-3x2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x3-gap-fill"></i> grid-3x3-gap-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x3-gap"></i> grid-3x3-gap
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-3x3"></i> grid-3x3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid-fill"></i> grid-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grid"></i> grid
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grip-horizontal"></i> grip-horizontal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-grip-vertical"></i> grip-vertical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hammer"></i> hammer
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-index-fill"></i> hand-index-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-index-thumb-fill"></i> hand-index-thumb-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-index-thumb"></i> hand-index-thumb
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-index"></i> hand-index
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-thumbs-down-fill"></i> hand-thumbs-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-thumbs-down"></i> hand-thumbs-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-thumbs-up-fill"></i> hand-thumbs-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hand-thumbs-up"></i> hand-thumbs-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-handbag-fill"></i> handbag-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-handbag"></i> handbag
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hash"></i> hash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-fill"></i> hdd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-network-fill"></i> hdd-network-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-network"></i> hdd-network
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-rack-fill"></i> hdd-rack-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-rack"></i> hdd-rack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-stack-fill"></i> hdd-stack-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd-stack"></i> hdd-stack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdd"></i> hdd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-headphones"></i> headphones
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-headset"></i> headset
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart-fill"></i> heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart-half"></i> heart-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart"></i> heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heptagon-fill"></i> heptagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heptagon-half"></i> heptagon-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heptagon"></i> heptagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hexagon-fill"></i> hexagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hexagon-half"></i> hexagon-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hexagon"></i> hexagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hourglass-bottom"></i> hourglass-bottom
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hourglass-split"></i> hourglass-split
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hourglass-top"></i> hourglass-top
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hourglass"></i> hourglass
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house-door-fill"></i> house-door-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house-door"></i> house-door
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house-fill"></i> house-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house"></i> house
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hr"></i> hr
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hurricane"></i> hurricane
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-image-alt"></i> image-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-image-fill"></i> image-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-image"></i> image
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-images"></i> images
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-inbox-fill"></i> inbox-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-inbox"></i> inbox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-inboxes-fill"></i> inboxes-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-inboxes"></i> inboxes
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info-circle-fill"></i> info-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info-circle"></i> info-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info-square-fill"></i> info-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info-square"></i> info-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info"></i> info
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-input-cursor-text"></i> input-cursor-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-input-cursor"></i> input-cursor
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-instagram"></i> instagram
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-intersect"></i> intersect
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-album"></i> journal-album
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-arrow-down"></i> journal-arrow-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-arrow-up"></i> journal-arrow-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-bookmark-fill"></i> journal-bookmark-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-bookmark"></i> journal-bookmark
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-check"></i> journal-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-code"></i> journal-code
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-medical"></i> journal-medical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-minus"></i> journal-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-plus"></i> journal-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-richtext"></i> journal-richtext
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-text"></i> journal-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal-x"></i> journal-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journal"></i> journal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-journals"></i> journals
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-joystick"></i> joystick
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-justify-left"></i> justify-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-justify-right"></i> justify-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-justify"></i> justify
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-kanban-fill"></i> kanban-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-kanban"></i> kanban
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-key-fill"></i> key-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-key"></i> key
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-keyboard-fill"></i> keyboard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-keyboard"></i> keyboard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ladder"></i> ladder
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lamp-fill"></i> lamp-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lamp"></i> lamp
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-laptop-fill"></i> laptop-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-laptop"></i> laptop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layer-backward"></i> layer-backward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layer-forward"></i> layer-forward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layers-fill"></i> layers-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layers-half"></i> layers-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layers"></i> layers
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-sidebar-inset-reverse"></i> layout-sidebar-inset-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-sidebar-inset"></i> layout-sidebar-inset
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-sidebar-reverse"></i> layout-sidebar-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-sidebar"></i> layout-sidebar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-split"></i> layout-split
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-text-sidebar-reverse"></i> layout-text-sidebar-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-text-sidebar"></i> layout-text-sidebar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-text-window-reverse"></i> layout-text-window-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-text-window"></i> layout-text-window
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-three-columns"></i> layout-three-columns
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-layout-wtf"></i> layout-wtf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-life-preserver"></i> life-preserver
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightbulb-fill"></i> lightbulb-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightbulb-off-fill"></i> lightbulb-off-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightbulb-off"></i> lightbulb-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightbulb"></i> lightbulb
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightning-charge-fill"></i> lightning-charge-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightning-charge"></i> lightning-charge
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightning-fill"></i> lightning-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lightning"></i> lightning
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-link-45deg"></i> link-45deg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-link"></i> link
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-linkedin"></i> linkedin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-check"></i> list-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-nested"></i> list-nested
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-ol"></i> list-ol
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-stars"></i> list-stars
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-task"></i> list-task
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-ul"></i> list-ul
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list"></i> list
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lock-fill"></i> lock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lock"></i> lock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mailbox"></i> mailbox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mailbox2"></i> mailbox2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-map-fill"></i> map-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-map"></i> map
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-markdown-fill"></i> markdown-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-markdown"></i> markdown
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mask"></i> mask
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-megaphone-fill"></i> megaphone-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-megaphone"></i> megaphone
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-app-fill"></i> menu-app-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-app"></i> menu-app
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-button-fill"></i> menu-button-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-button-wide-fill"></i> menu-button-wide-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-button-wide"></i> menu-button-wide
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-button"></i> menu-button
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-down"></i> menu-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-menu-up"></i> menu-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mic-fill"></i> mic-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mic-mute-fill"></i> mic-mute-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mic-mute"></i> mic-mute
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mic"></i> mic
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-minecart-loaded"></i> minecart-loaded
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-minecart"></i> minecart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-moisture"></i> moisture
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-moon-fill"></i> moon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-moon-stars-fill"></i> moon-stars-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-moon-stars"></i> moon-stars
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-moon"></i> moon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse-fill"></i> mouse-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse"></i> mouse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse2-fill"></i> mouse2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse2"></i> mouse2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse3-fill"></i> mouse3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mouse3"></i> mouse3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-music-note-beamed"></i> music-note-beamed
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-music-note-list"></i> music-note-list
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-music-note"></i> music-note
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-music-player-fill"></i> music-player-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-music-player"></i> music-player
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-newspaper"></i> newspaper
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-node-minus-fill"></i> node-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-node-minus"></i> node-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-node-plus-fill"></i> node-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-node-plus"></i> node-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-nut-fill"></i> nut-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-nut"></i> nut
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-octagon-fill"></i> octagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-octagon-half"></i> octagon-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-octagon"></i> octagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-option"></i> option
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-outlet"></i> outlet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-paint-bucket"></i> paint-bucket
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-palette-fill"></i> palette-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-palette"></i> palette
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-palette2"></i> palette2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-paperclip"></i> paperclip
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-paragraph"></i> paragraph
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-check-fill"></i> patch-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-check"></i> patch-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-exclamation-fill"></i> patch-exclamation-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-exclamation"></i> patch-exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-minus-fill"></i> patch-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-minus"></i> patch-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-plus-fill"></i> patch-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-plus"></i> patch-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-question-fill"></i> patch-question-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-patch-question"></i> patch-question
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause-btn-fill"></i> pause-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause-btn"></i> pause-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause-circle-fill"></i> pause-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause-circle"></i> pause-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause-fill"></i> pause-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pause"></i> pause
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-peace-fill"></i> peace-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-peace"></i> peace
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pen-fill"></i> pen-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pen"></i> pen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pencil-fill"></i> pencil-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pencil-square"></i> pencil-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pencil"></i> pencil
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pentagon-fill"></i> pentagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pentagon-half"></i> pentagon-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pentagon"></i> pentagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-people-fill"></i> people-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-people"></i> people
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-percent"></i> percent
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-badge-fill"></i> person-badge-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-badge"></i> person-badge
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-bounding-box"></i> person-bounding-box
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-check-fill"></i> person-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-check"></i> person-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-circle"></i> person-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-dash-fill"></i> person-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-dash"></i> person-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-fill"></i> person-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-lines-fill"></i> person-lines-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-plus-fill"></i> person-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-plus"></i> person-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-square"></i> person-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-x-fill"></i> person-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-x"></i> person-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person"></i> person
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-fill"></i> phone-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-landscape-fill"></i> phone-landscape-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-landscape"></i> phone-landscape
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-vibrate-fill"></i> phone-vibrate-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-vibrate"></i> phone-vibrate
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone"></i> phone
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pie-chart-fill"></i> pie-chart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pie-chart"></i> pie-chart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin-angle-fill"></i> pin-angle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin-angle"></i> pin-angle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin-fill"></i> pin-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin"></i> pin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pip-fill"></i> pip-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pip"></i> pip
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play-btn-fill"></i> play-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play-btn"></i> play-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play-circle-fill"></i> play-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play-circle"></i> play-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play-fill"></i> play-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-play"></i> play
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plug-fill"></i> plug-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plug"></i> plug
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-circle-dotted"></i> plus-circle-dotted
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-circle-fill"></i> plus-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-circle"></i> plus-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-square-dotted"></i> plus-square-dotted
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-square-fill"></i> plus-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-square"></i> plus-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus"></i> plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-power"></i> power
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-printer-fill"></i> printer-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-printer"></i> printer
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-puzzle-fill"></i> puzzle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-puzzle"></i> puzzle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-circle-fill"></i> question-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-circle"></i> question-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-diamond-fill"></i> question-diamond-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-diamond"></i> question-diamond
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-octagon-fill"></i> question-octagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-octagon"></i> question-octagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-square-fill"></i> question-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-square"></i> question-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question"></i> question
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rainbow"></i> rainbow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-receipt-cutoff"></i> receipt-cutoff
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-receipt"></i> receipt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reception-0"></i> reception-0
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reception-1"></i> reception-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reception-2"></i> reception-2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reception-3"></i> reception-3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reception-4"></i> reception-4
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record-btn-fill"></i> record-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record-btn"></i> record-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record-circle-fill"></i> record-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record-circle"></i> record-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record-fill"></i> record-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record"></i> record
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record2-fill"></i> record2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-record2"></i> record2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reply-all-fill"></i> reply-all-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reply-all"></i> reply-all
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reply-fill"></i> reply-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reply"></i> reply
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rss-fill"></i> rss-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rss"></i> rss
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rulers"></i> rulers
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-save-fill"></i> save-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-save"></i> save
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-save2-fill"></i> save2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-save2"></i> save2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-scissors"></i> scissors
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-screwdriver"></i> screwdriver
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-search"></i> search
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-segmented-nav"></i> segmented-nav
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-server"></i> server
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-share-fill"></i> share-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-share"></i> share
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-check"></i> shield-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-exclamation"></i> shield-exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill-check"></i> shield-fill-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill-exclamation"></i> shield-fill-exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill-minus"></i> shield-fill-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill-plus"></i> shield-fill-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill-x"></i> shield-fill-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-fill"></i> shield-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-lock-fill"></i> shield-lock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-lock"></i> shield-lock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-minus"></i> shield-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-plus"></i> shield-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-shaded"></i> shield-shaded
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-slash-fill"></i> shield-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-slash"></i> shield-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield-x"></i> shield-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shield"></i> shield
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shift-fill"></i> shift-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shift"></i> shift
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shop-window"></i> shop-window
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shop"></i> shop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-shuffle"></i> shuffle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost-2-fill"></i> signpost-2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost-2"></i> signpost-2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost-fill"></i> signpost-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost-split-fill"></i> signpost-split-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost-split"></i> signpost-split
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signpost"></i> signpost
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sim-fill"></i> sim-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sim"></i> sim
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward-btn-fill"></i> skip-backward-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward-btn"></i> skip-backward-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward-circle-fill"></i> skip-backward-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward-circle"></i> skip-backward-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward-fill"></i> skip-backward-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-backward"></i> skip-backward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end-btn-fill"></i> skip-end-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end-btn"></i> skip-end-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end-circle-fill"></i> skip-end-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end-circle"></i> skip-end-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end-fill"></i> skip-end-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-end"></i> skip-end
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward-btn-fill"></i> skip-forward-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward-btn"></i> skip-forward-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward-circle-fill"></i> skip-forward-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward-circle"></i> skip-forward-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward-fill"></i> skip-forward-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-forward"></i> skip-forward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start-btn-fill"></i> skip-start-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start-btn"></i> skip-start-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start-circle-fill"></i> skip-start-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start-circle"></i> skip-start-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start-fill"></i> skip-start-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skip-start"></i> skip-start
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slack"></i> slack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash-circle-fill"></i> slash-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash-circle"></i> slash-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash-square-fill"></i> slash-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash-square"></i> slash-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash"></i> slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sliders"></i> sliders
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-smartwatch"></i> smartwatch
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-snow"></i> snow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-snow2"></i> snow2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-snow3"></i> snow3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-alpha-down-alt"></i> sort-alpha-down-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-alpha-down"></i> sort-alpha-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-alpha-up-alt"></i> sort-alpha-up-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-alpha-up"></i> sort-alpha-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-down-alt"></i> sort-down-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-down"></i> sort-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-numeric-down-alt"></i> sort-numeric-down-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-numeric-down"></i> sort-numeric-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-numeric-up-alt"></i> sort-numeric-up-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-numeric-up"></i> sort-numeric-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-up-alt"></i> sort-up-alt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sort-up"></i> sort-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-soundwave"></i> soundwave
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-speaker-fill"></i> speaker-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-speaker"></i> speaker
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-speedometer"></i> speedometer
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-speedometer2"></i> speedometer2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-spellcheck"></i> spellcheck
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-square-fill"></i> square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-square-half"></i> square-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-square"></i> square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stack"></i> stack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-star-fill"></i> star-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-star-half"></i> star-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-star"></i> star
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stars"></i> stars
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stickies-fill"></i> stickies-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stickies"></i> stickies
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sticky-fill"></i> sticky-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sticky"></i> sticky
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop-btn-fill"></i> stop-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop-btn"></i> stop-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop-circle-fill"></i> stop-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop-circle"></i> stop-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop-fill"></i> stop-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stop"></i> stop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stoplights-fill"></i> stoplights-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stoplights"></i> stoplights
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stopwatch-fill"></i> stopwatch-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stopwatch"></i> stopwatch
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-subtract"></i> subtract
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-club-fill"></i> suit-club-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-club"></i> suit-club
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-diamond-fill"></i> suit-diamond-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-diamond"></i> suit-diamond
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-heart-fill"></i> suit-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-heart"></i> suit-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-spade-fill"></i> suit-spade-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-suit-spade"></i> suit-spade
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sun-fill"></i> sun-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sun"></i> sun
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sunglasses"></i> sunglasses
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sunrise-fill"></i> sunrise-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sunrise"></i> sunrise
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sunset-fill"></i> sunset-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sunset"></i> sunset
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-symmetry-horizontal"></i> symmetry-horizontal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-symmetry-vertical"></i> symmetry-vertical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-table"></i> table
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tablet-fill"></i> tablet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tablet-landscape-fill"></i> tablet-landscape-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tablet-landscape"></i> tablet-landscape
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tablet"></i> tablet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tag-fill"></i> tag-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tag"></i> tag
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tags-fill"></i> tags-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tags"></i> tags
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telegram"></i> telegram
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-fill"></i> telephone-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-forward-fill"></i> telephone-forward-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-forward"></i> telephone-forward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-inbound-fill"></i> telephone-inbound-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-inbound"></i> telephone-inbound
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-minus-fill"></i> telephone-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-minus"></i> telephone-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-outbound-fill"></i> telephone-outbound-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-outbound"></i> telephone-outbound
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-plus-fill"></i> telephone-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-plus"></i> telephone-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-x-fill"></i> telephone-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone-x"></i> telephone-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-telephone"></i> telephone
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-fill"></i> terminal-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal"></i> terminal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-center"></i> text-center
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-indent-left"></i> text-indent-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-indent-right"></i> text-indent-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-left"></i> text-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-paragraph"></i> text-paragraph
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-text-right"></i> text-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-textarea-resize"></i> textarea-resize
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-textarea-t"></i> textarea-t
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-textarea"></i> textarea
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer-half"></i> thermometer-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer-high"></i> thermometer-high
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer-low"></i> thermometer-low
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer-snow"></i> thermometer-snow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer-sun"></i> thermometer-sun
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thermometer"></i> thermometer
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-three-dots-vertical"></i> three-dots-vertical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-three-dots"></i> three-dots
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggle-off"></i> toggle-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggle-on"></i> toggle-on
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggle2-off"></i> toggle2-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggle2-on"></i> toggle2-on
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggles"></i> toggles
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-toggles2"></i> toggles2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tools"></i> tools
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tornado"></i> tornado
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash-fill"></i> trash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash"></i> trash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash2-fill"></i> trash2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash2"></i> trash2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tree-fill"></i> tree-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tree"></i> tree
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-triangle-fill"></i> triangle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-triangle-half"></i> triangle-half
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-triangle"></i> triangle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trophy-fill"></i> trophy-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trophy"></i> trophy
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tropical-storm"></i> tropical-storm
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-truck-flatbed"></i> truck-flatbed
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-truck"></i> truck
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tsunami"></i> tsunami
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tv-fill"></i> tv-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tv"></i> tv
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-twitch"></i> twitch
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-twitter"></i> twitter
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-bold"></i> type-bold
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-h1"></i> type-h1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-h2"></i> type-h2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-h3"></i> type-h3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-italic"></i> type-italic
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-strikethrough"></i> type-strikethrough
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type-underline"></i> type-underline
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-type"></i> type
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ui-checks-grid"></i> ui-checks-grid
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ui-checks"></i> ui-checks
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ui-radios-grid"></i> ui-radios-grid
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ui-radios"></i> ui-radios
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-umbrella-fill"></i> umbrella-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-umbrella"></i> umbrella
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-union"></i> union
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-unlock-fill"></i> unlock-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-unlock"></i> unlock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-upc-scan"></i> upc-scan
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-upc"></i> upc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-upload"></i> upload
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-vector-pen"></i> vector-pen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-view-list"></i> view-list
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-view-stacked"></i> view-stacked
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-vinyl-fill"></i> vinyl-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-vinyl"></i> vinyl
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-voicemail"></i> voicemail
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-down-fill"></i> volume-down-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-down"></i> volume-down
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-mute-fill"></i> volume-mute-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-mute"></i> volume-mute
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-off-fill"></i> volume-off-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-off"></i> volume-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-up-fill"></i> volume-up-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-volume-up"></i> volume-up
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-vr"></i> vr
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wallet-fill"></i> wallet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wallet"></i> wallet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wallet2"></i> wallet2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-watch"></i> watch
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-water"></i> water
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-whatsapp"></i> whatsapp
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wifi-1"></i> wifi-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wifi-2"></i> wifi-2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wifi-off"></i> wifi-off
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wifi"></i> wifi
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wind"></i> wind
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-dock"></i> window-dock
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-sidebar"></i> window-sidebar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window"></i> window
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wrench"></i> wrench
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-circle-fill"></i> x-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-circle"></i> x-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-diamond-fill"></i> x-diamond-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-diamond"></i> x-diamond
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-octagon-fill"></i> x-octagon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-octagon"></i> x-octagon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-square-fill"></i> x-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-square"></i> x-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x"></i> x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-youtube"></i> youtube
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-zoom-in"></i> zoom-in
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-zoom-out"></i> zoom-out
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bank"></i> bank
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bank2"></i> bank2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bell-slash-fill"></i> bell-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bell-slash"></i> bell-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cash-coin"></i> cash-coin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-check-lg"></i> check-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-coin"></i> coin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-bitcoin"></i> currency-bitcoin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-dollar"></i> currency-dollar
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-euro"></i> currency-euro
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-exchange"></i> currency-exchange
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-pound"></i> currency-pound
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-yen"></i> currency-yen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dash-lg"></i> dash-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-exclamation-lg"></i> exclamation-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-pdf-fill"></i> file-earmark-pdf-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-earmark-pdf"></i> file-earmark-pdf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-pdf-fill"></i> file-pdf-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-file-pdf"></i> file-pdf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gender-ambiguous"></i> gender-ambiguous
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gender-female"></i> gender-female
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gender-male"></i> gender-male
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gender-trans"></i> gender-trans
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-headset-vr"></i> headset-vr
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-info-lg"></i> info-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mastodon"></i> mastodon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-messenger"></i> messenger
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-piggy-bank-fill"></i> piggy-bank-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-piggy-bank"></i> piggy-bank
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin-map-fill"></i> pin-map-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pin-map"></i> pin-map
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-lg"></i> plus-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-question-lg"></i> question-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-recycle"></i> recycle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-reddit"></i> reddit
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-safe-fill"></i> safe-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-safe2-fill"></i> safe2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-safe2"></i> safe2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sd-card-fill"></i> sd-card-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sd-card"></i> sd-card
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-skype"></i> skype
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-slash-lg"></i> slash-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-translate"></i> translate
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-x-lg"></i> x-lg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-safe"></i> safe
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-apple"></i> apple
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-microsoft"></i> microsoft
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-windows"></i> windows
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-behance"></i> behance
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dribbble"></i> dribbble
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-line"></i> line
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-medium"></i> medium
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-paypal"></i> paypal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pinterest"></i> pinterest
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-signal"></i> signal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-snapchat"></i> snapchat
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-spotify"></i> spotify
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-stack-overflow"></i> stack-overflow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-strava"></i> strava
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wordpress"></i> wordpress
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-vimeo"></i> vimeo
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-activity"></i> activity
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel2-fill"></i> easel2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel2"></i> easel2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel3-fill"></i> easel3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-easel3"></i> easel3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fan"></i> fan
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fingerprint"></i> fingerprint
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-graph-down-arrow"></i> graph-down-arrow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-graph-up-arrow"></i> graph-up-arrow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hypnotize"></i> hypnotize
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-magic"></i> magic
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-rolodex"></i> person-rolodex
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-video"></i> person-video
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-video2"></i> person-video2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-video3"></i> person-video3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-workspace"></i> person-workspace
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-radioactive"></i> radioactive
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-webcam-fill"></i> webcam-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-webcam"></i> webcam
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-yin-yang"></i> yin-yang
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bandaid-fill"></i> bandaid-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bandaid"></i> bandaid
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bluetooth"></i> bluetooth
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-body-text"></i> body-text
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-boombox"></i> boombox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-boxes"></i> boxes
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dpad-fill"></i> dpad-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dpad"></i> dpad
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ear-fill"></i> ear-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ear"></i> ear
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-check-1"></i> envelope-check-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-check-fill"></i> envelope-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-check"></i> envelope-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-dash-1"></i> envelope-dash-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-dash-fill"></i> envelope-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-dash"></i> envelope-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-exclamation-1"></i> envelope-exclamation-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-exclamation-fill"></i> envelope-exclamation-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-exclamation"></i> envelope-exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-plus-fill"></i> envelope-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-plus"></i> envelope-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-slash-1"></i> envelope-slash-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-slash-fill"></i> envelope-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-slash"></i> envelope-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-x-1"></i> envelope-x-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-x-fill"></i> envelope-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-x"></i> envelope-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-explicit-fill"></i> explicit-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-explicit"></i> explicit
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-git"></i> git
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-infinity"></i> infinity
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-columns-reverse"></i> list-columns-reverse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-list-columns"></i> list-columns
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-meta"></i> meta
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mortorboard-fill"></i> mortorboard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mortorboard"></i> mortorboard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-nintendo-switch"></i> nintendo-switch
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pc-display-horizontal"></i> pc-display-horizontal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pc-display"></i> pc-display
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pc-horizontal"></i> pc-horizontal
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pc"></i> pc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-playstation"></i> playstation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plus-slash-minus"></i> plus-slash-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-projector-fill"></i> projector-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-projector"></i> projector
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-qr-code-scan"></i> qr-code-scan
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-qr-code"></i> qr-code
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-quora"></i> quora
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-quote"></i> quote
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-robot"></i> robot
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-check-fill"></i> send-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-check"></i> send-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-dash-fill"></i> send-dash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-dash"></i> send-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-exclamation-1"></i> send-exclamation-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-exclamation-fill"></i> send-exclamation-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-exclamation"></i> send-exclamation
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-fill"></i> send-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-plus-fill"></i> send-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-plus"></i> send-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-slash-fill"></i> send-slash-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-slash"></i> send-slash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-x-fill"></i> send-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send-x"></i> send-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-send"></i> send
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-steam"></i> steam
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-dash-1"></i> terminal-dash-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-dash"></i> terminal-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-plus"></i> terminal-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-split"></i> terminal-split
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket-detailed-fill"></i> ticket-detailed-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket-detailed"></i> ticket-detailed
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket-fill"></i> ticket-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket-perforated-fill"></i> ticket-perforated-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket-perforated"></i> ticket-perforated
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ticket"></i> ticket
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-tiktok"></i> tiktok
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-dash"></i> window-dash
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-desktop"></i> window-desktop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-fullscreen"></i> window-fullscreen
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-plus"></i> window-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-split"></i> window-split
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-stack"></i> window-stack
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-window-x"></i> window-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-xbox"></i> xbox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ethernet"></i> ethernet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdmi-fill"></i> hdmi-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hdmi"></i> hdmi
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-c-fill"></i> usb-c-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-c"></i> usb-c
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-fill"></i> usb-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-plug-fill"></i> usb-plug-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-plug"></i> usb-plug
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-symbol"></i> usb-symbol
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb"></i> usb
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-boombox-fill"></i> boombox-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-displayport-1"></i> displayport-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-displayport"></i> displayport
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-gpu-card"></i> gpu-card
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-memory"></i> memory
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-modem-fill"></i> modem-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-modem"></i> modem
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-motherboard-fill"></i> motherboard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-motherboard"></i> motherboard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-optical-audio-fill"></i> optical-audio-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-optical-audio"></i> optical-audio
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pci-card"></i> pci-card
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-router-fill"></i> router-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-router"></i> router
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ssd-fill"></i> ssd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ssd"></i> ssd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thunderbolt-fill"></i> thunderbolt-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-thunderbolt"></i> thunderbolt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-drive-fill"></i> usb-drive-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-drive"></i> usb-drive
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-micro-fill"></i> usb-micro-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-micro"></i> usb-micro
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-mini-fill"></i> usb-mini-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-usb-mini"></i> usb-mini
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cloud-haze2"></i> cloud-haze2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-device-hdd-fill"></i> device-hdd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-device-hdd"></i> device-hdd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-device-ssd-fill"></i> device-ssd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-device-ssd"></i> device-ssd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-displayport-fill"></i> displayport-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mortarboard-fill"></i> mortarboard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-mortarboard"></i> mortarboard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-terminal-x"></i> terminal-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-through-heart-fill"></i> arrow-through-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-arrow-through-heart"></i> arrow-through-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-sd-fill"></i> badge-sd-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-badge-sd"></i> badge-sd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-heart-fill"></i> bag-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-bag-heart"></i> bag-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-balloon-fill"></i> balloon-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-balloon-heart-fill"></i> balloon-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-balloon-heart"></i> balloon-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-balloon"></i> balloon
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box2-fill"></i> box2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box2-heart-fill"></i> box2-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box2-heart"></i> box2-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box2"></i> box2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-braces-asterisk"></i> braces-asterisk
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-heart-fill"></i> calendar-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar-heart"></i> calendar-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-heart-fill"></i> calendar2-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-calendar2-heart"></i> calendar2-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-heart-fill"></i> chat-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-heart"></i> chat-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-heart-fill"></i> chat-left-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-left-heart"></i> chat-left-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-heart-fill"></i> chat-right-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-right-heart"></i> chat-right-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-heart-fill"></i> chat-square-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-chat-square-heart"></i> chat-square-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-check-fill"></i> clipboard-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-data-fill"></i> clipboard-data-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-fill"></i> clipboard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-heart-fill"></i> clipboard-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-heart"></i> clipboard-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-minus-fill"></i> clipboard-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-plus-fill"></i> clipboard-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-pulse"></i> clipboard-pulse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard-x-fill"></i> clipboard-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-check-fill"></i> clipboard2-check-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-check"></i> clipboard2-check
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-data-fill"></i> clipboard2-data-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-data"></i> clipboard2-data
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-fill"></i> clipboard2-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-heart-fill"></i> clipboard2-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-heart"></i> clipboard2-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-minus-fill"></i> clipboard2-minus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-minus"></i> clipboard2-minus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-plus-fill"></i> clipboard2-plus-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-plus"></i> clipboard2-plus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-pulse-fill"></i> clipboard2-pulse-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-pulse"></i> clipboard2-pulse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-x-fill"></i> clipboard2-x-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2-x"></i> clipboard2-x
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-clipboard2"></i> clipboard2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-kiss-fill"></i> emoji-kiss-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-emoji-kiss"></i> emoji-kiss
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-heart-fill"></i> envelope-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-heart"></i> envelope-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-open-heart-fill"></i> envelope-open-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-open-heart"></i> envelope-open-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-paper-fill"></i> envelope-paper-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-paper-heart-fill"></i> envelope-paper-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-paper-heart"></i> envelope-paper-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-envelope-paper"></i> envelope-paper
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-aac"></i> filetype-aac
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-ai"></i> filetype-ai
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-bmp"></i> filetype-bmp
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-cs"></i> filetype-cs
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-css"></i> filetype-css
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-csv"></i> filetype-csv
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-doc"></i> filetype-doc
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-docx"></i> filetype-docx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-exe"></i> filetype-exe
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-gif"></i> filetype-gif
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-heic"></i> filetype-heic
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-html"></i> filetype-html
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-java"></i> filetype-java
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-jpg"></i> filetype-jpg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-js"></i> filetype-js
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-jsx"></i> filetype-jsx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-key"></i> filetype-key
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-m4p"></i> filetype-m4p
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-md"></i> filetype-md
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-mdx"></i> filetype-mdx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-mov"></i> filetype-mov
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-mp3"></i> filetype-mp3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-mp4"></i> filetype-mp4
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-otf"></i> filetype-otf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-pdf"></i> filetype-pdf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-php"></i> filetype-php
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-png"></i> filetype-png
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-ppt-1"></i> filetype-ppt-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-ppt"></i> filetype-ppt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-psd"></i> filetype-psd
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-py"></i> filetype-py
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-raw"></i> filetype-raw
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-rb"></i> filetype-rb
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-sass"></i> filetype-sass
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-scss"></i> filetype-scss
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-sh"></i> filetype-sh
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-svg"></i> filetype-svg
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-tiff"></i> filetype-tiff
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-tsx"></i> filetype-tsx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-ttf"></i> filetype-ttf
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-txt"></i> filetype-txt
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-wav"></i> filetype-wav
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-woff"></i> filetype-woff
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-xls-1"></i> filetype-xls-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-xls"></i> filetype-xls
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-xml"></i> filetype-xml
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-yml"></i> filetype-yml
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart-arrow"></i> heart-arrow
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart-pulse-fill"></i> heart-pulse-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heart-pulse"></i> heart-pulse
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heartbreak-fill"></i> heartbreak-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-heartbreak"></i> heartbreak
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hearts"></i> hearts
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hospital-fill"></i> hospital-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-hospital"></i> hospital
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house-heart-fill"></i> house-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-house-heart"></i> house-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-incognito"></i> incognito
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-magnet-fill"></i> magnet-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-magnet"></i> magnet
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-heart"></i> person-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-person-hearts"></i> person-hearts
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-phone-flip"></i> phone-flip
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-plugin"></i> plugin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postage-fill"></i> postage-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postage-heart-fill"></i> postage-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postage-heart"></i> postage-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postage"></i> postage
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postcard-fill"></i> postcard-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postcard-heart-fill"></i> postcard-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postcard-heart"></i> postcard-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-postcard"></i> postcard
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-search-heart-fill"></i> search-heart-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-search-heart"></i> search-heart
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sliders2-vertical"></i> sliders2-vertical
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sliders2"></i> sliders2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash3-fill"></i> trash3-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-trash3"></i> trash3
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-valentine"></i> valentine
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-valentine2"></i> valentine2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wrench-adjustable-circle-fill"></i> wrench-adjustable-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wrench-adjustable-circle"></i> wrench-adjustable-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wrench-adjustable"></i> wrench-adjustable
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-json"></i> filetype-json
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-pptx"></i> filetype-pptx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-xlsx"></i> filetype-xlsx
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-circle-1"></i> 1-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-circle-fill-1"></i> 1-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-circle-fill"></i> 1-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-circle"></i> 1-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-square-fill"></i> 1-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-1-square"></i> 1-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-circle-1"></i> 2-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-circle-fill-1"></i> 2-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-circle-fill"></i> 2-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-circle"></i> 2-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-square-fill"></i> 2-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-2-square"></i> 2-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-circle-1"></i> 3-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-circle-fill-1"></i> 3-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-circle-fill"></i> 3-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-circle"></i> 3-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-square-fill"></i> 3-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-3-square"></i> 3-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-circle-1"></i> 4-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-circle-fill-1"></i> 4-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-circle-fill"></i> 4-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-circle"></i> 4-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-square-fill"></i> 4-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-4-square"></i> 4-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-circle-1"></i> 5-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-circle-fill-1"></i> 5-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-circle-fill"></i> 5-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-circle"></i> 5-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-square-fill"></i> 5-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-5-square"></i> 5-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-circle-1"></i> 6-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-circle-fill-1"></i> 6-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-circle-fill"></i> 6-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-circle"></i> 6-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-square-fill"></i> 6-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-6-square"></i> 6-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-circle-1"></i> 7-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-circle-fill-1"></i> 7-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-circle-fill"></i> 7-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-circle"></i> 7-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-square-fill"></i> 7-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-7-square"></i> 7-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-circle-1"></i> 8-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-circle-fill-1"></i> 8-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-circle-fill"></i> 8-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-circle"></i> 8-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-square-fill"></i> 8-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-8-square"></i> 8-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-circle-1"></i> 9-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-circle-fill-1"></i> 9-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-circle-fill"></i> 9-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-circle"></i> 9-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-square-fill"></i> 9-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-9-square"></i> 9-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-airplane-engines-fill"></i> airplane-engines-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-airplane-engines"></i> airplane-engines
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-airplane-fill"></i> airplane-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-airplane"></i> airplane
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-alexa"></i> alexa
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-alipay"></i> alipay
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-android"></i> android
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-android2"></i> android2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-fill"></i> box-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-box-seam-fill"></i> box-seam-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-browser-chrome"></i> browser-chrome
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-browser-edge"></i> browser-edge
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-browser-firefox"></i> browser-firefox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-browser-safari"></i> browser-safari
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-circle-1"></i> c-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-circle-fill-1"></i> c-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-circle-fill"></i> c-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-circle"></i> c-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-square-fill"></i> c-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-c-square"></i> c-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-capsule-pill"></i> capsule-pill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-capsule"></i> capsule
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-car-front-fill"></i> car-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-car-front"></i> car-front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cassette-fill"></i> cassette-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cassette"></i> cassette
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-circle-1"></i> cc-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-circle-fill-1"></i> cc-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-circle-fill"></i> cc-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-circle"></i> cc-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-square-fill"></i> cc-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cc-square"></i> cc-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cup-hot-fill"></i> cup-hot-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-cup-hot"></i> cup-hot
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-currency-rupee"></i> currency-rupee
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-dropbox"></i> dropbox
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-escape"></i> escape
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward-btn-fill"></i> fast-forward-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward-btn"></i> fast-forward-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward-circle-fill"></i> fast-forward-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward-circle"></i> fast-forward-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward-fill"></i> fast-forward-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fast-forward"></i> fast-forward
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-filetype-sql"></i> filetype-sql
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fire"></i> fire
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-google-play"></i> google-play
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-circle-1"></i> h-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-circle-fill-1"></i> h-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-circle-fill"></i> h-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-circle"></i> h-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-square-fill"></i> h-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-h-square"></i> h-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-indent"></i> indent
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lungs-fill"></i> lungs-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-lungs"></i> lungs
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-microsoft-teams"></i> microsoft-teams
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-circle-1"></i> p-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-circle-fill-1"></i> p-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-circle-fill"></i> p-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-circle"></i> p-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-square-fill"></i> p-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-p-square"></i> p-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pass-fill"></i> pass-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-pass"></i> pass
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-prescription"></i> prescription
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-prescription2"></i> prescription2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-circle-1"></i> r-circle-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-circle-fill-1"></i> r-circle-fill-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-circle-fill"></i> r-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-circle"></i> r-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-square-fill"></i> r-square-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-r-square"></i> r-square
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-repeat-1"></i> repeat-1
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-repeat"></i> repeat
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind-btn-fill"></i> rewind-btn-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind-btn"></i> rewind-btn
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind-circle-fill"></i> rewind-circle-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind-circle"></i> rewind-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind-fill"></i> rewind-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-rewind"></i> rewind
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-freight-front-fill"></i> train-freight-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-freight-front"></i> train-freig
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-front-fill"></i> train-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-front"></i> train-front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-lightrail-front-fill"></i> train-lightrail-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-train-lightrail-front"></i> train-lightrail-front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-truck-front-fill"></i> truck-front-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-truck-front"></i> truck-front
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ubuntu"></i> ubuntu
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-unindent"></i> unindent
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-unity"></i> unity
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-universal-access-circle"></i> universal-access-circle
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-universal-access"></i> universal-access
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-virus"></i> virus
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-virus2"></i> virus2
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-wechat"></i> wechat
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-yelp"></i> yelp
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-stop-fill"></i> sign-stop-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-stop-lights-fill"></i> sign-stop-lights-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-stop-lights"></i> sign-stop-lights
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-stop"></i> sign-stop
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-left-fill"></i> sign-turn-left-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-left"></i> sign-turn-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-right-fill"></i> sign-turn-right-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-right"></i> sign-turn-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-slight-left-fill"></i> sign-turn-slight-left-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-slight-left"></i> sign-turn-slight-left
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-slight-right-fill"></i> sign-turn-slight-right-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-turn-slight-right"></i> sign-turn-slight-right
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-yield-fill"></i> sign-yield-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-sign-yield"></i> sign-yield
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ev-station-fill"></i> ev-station-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-ev-station"></i> ev-station
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fuel-pump-diesel-fill"></i> fuel-pump-diesel-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fuel-pump-diesel"></i> fuel-pump-diesel
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fuel-pump-fill"></i> fuel-pump-fill
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="bi bi-fuel-pump"></i> fuel-pump
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BootstrapIcon;